export default __webpack_public_path__ + "static/media/Classwin_Menu-pop-up_5-Certificate.a49f1464.jpeg";